import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-list-view-filters-form',
  templateUrl: './list-view-filters-form.component.html',
  styleUrls: ['./list-view-filters-form.component.scss'],
})
export class ListViewFiltersFormComponent {
  @Input() filters: any;
  @Input() isMobileView: boolean;
  @Input() filtersForm: UntypedFormGroup;

  @Output() filtersCleared: EventEmitter<null> = new EventEmitter();
  @Output() typeaheadCleared: EventEmitter<null> = new EventEmitter();
  @Output() filtersApplied: EventEmitter<null> = new EventEmitter();
  @Output() formCreated: EventEmitter<null> = new EventEmitter();
  @Output() typeAheadOptionSelected: EventEmitter<unknown> = new EventEmitter();

  handleTypeaheadOptionSelected(evt) {
    this.typeAheadOptionSelected.emit(evt);
  }
}
